import { Fragment, FunctionComponent } from 'react'
import { ResetStyles } from '@conexasaude/conexa-hero'
import { useGlobalStyles } from './styles'
import { Global } from '@emotion/react'
import useHeight from '@/utils/useHeight'

export const HeroWrapper: FunctionComponent = ({ children }) => {
  const height = useHeight()
  const styles = useGlobalStyles({ height })

  return (
    <Fragment>
      <ResetStyles />
      <Global styles={styles.global} />
      {children}
    </Fragment>
  )
}
